import isEqual from 'lodash/isEqual';
import { cacheTTL, isApiMocked } from '@/config';
import { ALL_KEYS } from '@/assets/dashboard/cache-keys';

class CacheService {
    store(props, { expiresAt = Date.now() + cacheTTL } = {}) {
        const item = {
            ...props,
            expiresAt
        };

        localStorage.setItem(props.key, JSON.stringify(item));
    }

    find(key, range, timeUnit) {
        const item = localStorage.getItem(key);

        if (!item) {
            return null;
        }

        const parsedItem = JSON.parse(item);

        if (
            parsedItem.expiresAt &&
            (Date.now() > parsedItem.expiresAt || (range && !isEqual(parsedItem.range, range)))
        ) {
            localStorage.removeItem(key);

            return null;
        }

        if (timeUnit !== parsedItem.timeUnit) {
            return null;
        }

        return parsedItem.value;
    }

    cleanLocalStorageFromExpiredKeys() {
        Object.keys(localStorage).forEach(key => {
            if (ALL_KEYS.some(cacheableKey => key.startsWith(cacheableKey))) {
                this.find(key);
            }
        });
    }

    // @TMP for development purposes (call it e.g. in main.js once)
    removeCacheRelatedKeysFromLocalStorage() {
        Object.keys(localStorage).forEach(key => {
            if (ALL_KEYS.some(cacheableKey => key.startsWith(cacheableKey))) {
                localStorage.removeItem(key);
            }
        });
    }

    handleRequest({
        key,
        range,
        timeUnit,
        onRequest,
        onCachedRequest,
        customCondition = null,
        isRequestForced = false
    }) {
        const storeKeyOnRealApi = (key, data) => {
            if (isApiMocked) {
                return;
            }

            const props = { key, data, range, timeUnit };

            this.store(props);
        };

        if (isApiMocked) {
            return onRequest(storeKeyOnRealApi);
        }

        this.cleanLocalStorageFromExpiredKeys();

        const value = this.find(key, range, timeUnit);

        if (isRequestForced) {
            return onRequest(storeKeyOnRealApi);
        }

        if (value && customCondition) {
            return customCondition(value) ? onCachedRequest(value) : onRequest(storeKeyOnRealApi);
        }

        return value ? onCachedRequest(value) : onRequest(storeKeyOnRealApi);
    }
}

export default CacheService;
